import { Component } from '@angular/core';

@Component({
    selector: 'app-introducing-family-central',
    templateUrl: './introducing-family-central.component.html',
    styleUrls: ['./introducing-family-central.component.css'],
    standalone: false
})
export class IntroducingFamilyCentralComponent {

}
